import { SettingsApiBase, SettingsBase } from 'src/api';
import { Injectable, inject } from '@angular/core';
import { MachineHistory } from './machine-history.model';
import { ColumnBaseConfig, columnBaseToSettings } from '../config-utils';
import { HttpClient } from '@angular/common/http';
import { apiRoots } from 'src/config';
import { US_BASE_URL } from 'src/api/tokens';

const machineHistorySettingsKey = 'maintenanceassistant_settings:machineHistorySettings';

export interface MachineHistorySettings extends SettingsBase<keyof MachineHistory> {}

export const machineHistoryColumnsBaseConfig: ColumnBaseConfig<MachineHistory> = [
  { key: 'undo', name: 'Reactivate Task', width: '80px' },
  { key: 'plantName', name: 'Plant', width: '150px' },
  { key: 'machineName', name: 'Machine', width: '150px' },
  { key: 'machineSerial', name: 'Serial Number', width: '150px' },
  { key: 'schenckId', name: 'Task ID Schenck', width: '150px' },
  { key: 'customerId', name: 'Task ID Customer', width: '150px', invisible: true },
  { key: 'title', name: 'Title', width: '150px' },
  { key: 'priority', name: 'Priority', width: '150px' },
  { key: 'responsibleCompany', name: 'Responsible Company', width: '150px' },
  { key: 'responsible', name: 'Task Responsible', width: '150px', invisible: true },
  { key: 'executive', name: 'Task Executive', width: '150px' },
  { key: 'executionDate', name: 'Execution Date', width: '150px' },
  { key: 'dueDate', name: 'Due Date', width: '150px' },
  { key: 'status', name: 'Status', width: '150px' },
  { key: 'description', name: 'Description', width: '150px', invisible: true },
  { key: 'component', name: 'Component', width: '150px' },
  { key: 'type', name: 'Task Type', width: '150px', invisible: true },
  { key: 'requiredTooling', name: 'Required Tooling', width: '150px', invisible: true },
  { key: 'possibleSpareParts', name: 'Possible Spare Parts', width: '150px', invisible: true },
  { key: 'expectedDurationMinutes', name: 'Expected Duration', width: '150px', invisible: true },
  { key: 'scheduling', name: 'Interval', width: '150px', invisible: true },
];

export const settingsDefaults: MachineHistorySettings = columnBaseToSettings(
  machineHistoryColumnsBaseConfig
);

@Injectable()
export class MachineHistorySettingsApi extends SettingsApiBase<
  keyof MachineHistory,
  MachineHistorySettings
> {
  constructor() {
    const usBaseUrl = inject(US_BASE_URL);
    const http = inject(HttpClient);

    const baseUrl = usBaseUrl + '/v1/currentuser/MaintenanceAssistant';
    const updateUrl = baseUrl + apiRoots.machineHistory;
    super(
      updateUrl,
      http,
      settingsDefaults,
      machineHistorySettingsKey,
      baseUrl,
      'machineHistorySettings'
    );
  }
}
